export default function planDisplayName(planId) {
  if (planId === 'SMALL BUSINESS') {
    return 'Basic';
  }

  if (planId === 'BASIC') {
    return 'Premium';
  }

  if (planId === 'CUSTOM' || planId === 'Custom' || planId === 'ENTERPRISECustom') {
    return 'Enterprise';
  }

  if (planId.endsWith('Custom')) {
    return planId.replace('Custom', ' - Custom');
  }

  return planId;
}